import {
    IonBackButton,
    IonButton,
    IonButtons,
    IonCardTitle,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonPage,
    IonRow,
    IonToolbar
} from '@ionic/react';
import './Singup.module.css';
import styles from './Singup.module.css'
import {arrowBack, helpOutline} from "ionicons/icons";
import CustomField from '../components/CustomField';
import {mapFieldsToUserFields, useSignupFields} from '../data/fields';
import {Action} from '../components/Action';
import {WaveLogin} from '../components/Wave';
import {useState} from 'react';
import {validateForm} from '../data/utils';
import {ErrorMsg} from "../typings/typings";

import {Keyboard} from "@capacitor/keyboard";
import {Capacitor} from "@capacitor/core";
import {signUp} from "../store/actions";
import {useHistory} from "react-router-dom";
import {debounce} from "lodash";
import GoogleButton from "../components/GoogleButton";
import pubSub from "../events/PubSub";
import EventType from "../constants/EventType";


const Signup = () => {
    const history = useHistory();
    const fields = useSignupFields();
    const init: ErrorMsg[] = []
    const [errors, setErrors] = useState(init);
    const [showFooter, setShowFooter] = useState(true)

    if (Capacitor.getPlatform() !== "web") {
        Keyboard.addListener('keyboardWillShow', info => {
            setShowFooter(false)
        });

        Keyboard.addListener('keyboardWillHide', () => {
            setShowFooter(true)
        });
    }


    const createAccount = () => {

        const errors = validateForm(fields);

        setErrors(errors);

        if (!errors.length) {
            signUp(mapFieldsToUserFields(fields)).then(() => {
                history.push("/rentals")
            }).catch(error =>
                pubSub.emit(EventType.TOAST_ERROR, EventType.TOAST_ERROR, "Error: " + error));
        }
    }
    const debouncedCreateAccount = debounce(createAccount, 500);
    const handleSignUp = () => {
        debouncedCreateAccount();
    };

    const keypress = (event: React.KeyboardEvent<HTMLIonButtonElement>) => {
        if (event.key === 'Enter') {
            handleSignUp()
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text="" className="custom-back"/>
                    </IonButtons>
                    <IonButtons slot="end">
                        <IonButton>
                            <IonIcon icon={helpOutline}/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <div className="dotted">
                    <IonGrid className="ion-padding">
                        <IonRow>
                            <IonCol size="12">
                                <IonCardTitle>Sign up</IonCardTitle>
                                <h5 className={styles.headingText}>Lets get to know each other</h5>
                            </IonCol>
                        </IonRow>

                        <IonRow onKeyDown={keypress} className="ion-margin-top ion-padding-top">
                            <IonCol size="12">

                                {fields.map((field, key) => {

                                    return <CustomField field={field} key={key} errors={errors}/>;
                                })}

                                <IonButton onKeyPress={(e) => {
                                    keypress(e)
                                }} className="custom-button" expand="block" onClick={handleSignUp}>
                                    <p className="text-button">Create
                                        account</p></IonButton>
                            </IonCol>
                            <GoogleButton />
                        </IonRow>
                    </IonGrid>
                </div>
            </IonContent>

            <IonFooter className="footer-wave" hidden={!showFooter}>
                <IonGrid className="ion-no-margin ion-no-padding">
                    <Action message="Already got an account?" text="Login" link="/login"/>
                    <WaveLogin/>
                </IonGrid>
            </IonFooter>
        </IonPage>
    );
};

export default Signup;
